"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString = require('query-string');
var encoder_1 = require("../../utils/encoder");
var postMessagesPubSub_1 = require("../../utils/postMessagesPubSub");
var paymentsApi_1 = require("../../paymentsApi");
var NO_INIT_MESSAGE = 'SDK not inited, use cashierPayments.init() firstly(or wait until init will be finished, if you already runned init())';
var defaultInternals = {
    allowedIframes: ['cashier-pci'],
    linkToIframe: 'https://cashier.wix.com/cashier-pci',
};
var CreditCard = /** @class */ (function () {
    function CreditCard(_a) {
        var appId = _a.appId, appInstanceId = _a.appInstanceId, host = _a.host, paymentModule = _a.paymentModule, localizeError = _a.localizeError, methodId = _a.methodId, orderId = _a.orderId, linkToWindow = _a.linkToWindow, selector = _a.selector, styles = _a.styles, query = _a.query, onMessage = _a.onMessage, onPaymentComplete = _a.onPaymentComplete, onPaymentStart = _a.onPaymentStart, onError = _a.onError, type = _a.type, linkToIframe = _a.linkToIframe;
        var _this = this;
        this.state = {
            loading: false,
            error: false
        };
        this.ccLoadTimer = null;
        this.installments = 1;
        this.listenToMessages = function () {
            _this.windowController.addEventListener('message', _this.handleMessageFromIframe, false);
        };
        this.handleIframeSizeUpdate = function (message) {
            _this.iframeNode.style.height = message.height ?
                message.height + 'px' :
                _this.iframeNode.style.height;
        };
        this.handleClientFormValidation = function (data) {
            if (_this.props.onMessage) {
                _this.props.onMessage('creditCard', { type: 'VALIDATION', isValid: Boolean(data.status === 'CLIENT_OK') });
            }
        };
        this.handleMessageFromIframe = function (event) {
            var data = event.data || { iframeName: '' };
            var iframeName = data.iframeName;
            if (defaultInternals.allowedIframes.indexOf(iframeName) !== -1) {
                var hashOfEvents = {
                    FORM_SIZE: _this.handleIframeSizeUpdate,
                    SIZE: _this.handleIframeSizeUpdate,
                    CLIENT_FORM_VALIDATION: _this.handleClientFormValidation,
                    SERVER_FORM_SUBMIT: function (message) {
                        var parsedResponse = message.message;
                        if (message.message && typeof message.message === 'string') {
                            try {
                                parsedResponse = JSON.parse(message.message);
                            }
                            catch (ex) {
                                parsedResponse = message.message;
                            }
                        }
                        if (parsedResponse && parsedResponse.paymentStatus && parsedResponse.paymentStatus.value === 'Pending3ds') {
                            var nextUrl = "https://cashier.wix.com/_api/payment-gateway-web/3ds?transactionKey=" + parsedResponse.transactionKey;
                            if (_this.windowController.top && _this.windowController.top.location) {
                                _this.windowController.top.location.replace(nextUrl);
                            }
                            else {
                                _this.windowController.location.replace(nextUrl);
                            }
                        }
                        else {
                            if (parsedResponse && parsedResponse.errorCode && _this.props.localizeError) {
                                _this.props.localizeError(parsedResponse.errorCode).then(function (errorMessage) {
                                    _this.props.onPaymentComplete && _this.props.onPaymentComplete('creditCard', __assign({}, message, { translatedError: errorMessage }));
                                });
                            }
                            else {
                                _this.props.onPaymentComplete && _this.props.onPaymentComplete('creditCard', message);
                            }
                        }
                    },
                    CLIENT_FORM_4_CARD_NUMBERS: function (message) { return _this.props.onMessage('creditCard', __assign({}, message, { message: "\u25CF\u25CF\u25CF\u25CF \u25CF\u25CF\u25CF\u25CF \u25CF\u25CF\u25CF\u25CF " + (message.cardNumber || '●●●●'), icon: message.cardType })); }
                };
                if (hashOfEvents[data.type]) {
                    hashOfEvents[data.type](data);
                }
                else {
                    if (data.type === 'PING' && data.status === 'INITED') {
                        _this.handleCCLoadFinished({ error: false });
                    }
                    if (_this.props.onMessage) {
                        _this.props.onMessage('creditCard', data);
                    }
                }
            }
        };
        this.sendCommand = function (command, mandatoryFields) {
            if (mandatoryFields === void 0) { mandatoryFields = {}; }
            if (_this.iframeNode && _this.iframeNode.contentWindow && _this.iframeNode.contentWindow.postMessage) {
                _this.iframeNode.contentWindow.postMessage({ type: command, payload: { mandatoryFields: mandatoryFields } }, '*');
            }
            else {
                console.error(NO_INIT_MESSAGE);
            }
        };
        this.handleCCLoadFinished = function (_a) {
            var error = _a.error;
            clearTimeout(_this.ccLoadTimer);
            _this.state.error = Boolean(error);
            _this.state.loading = false;
            if (error) {
                _this.ccLoadReject({
                    status: 'FAILURE',
                    errorCode: '',
                    translatedError: '',
                    paymentMethod: 'creditCard'
                });
            }
            else {
                _this.ccLoadResolve({
                    status: 'OK',
                    errorCode: '',
                    translatedError: '',
                    paymentMethod: 'creditCard'
                });
            }
        };
        this.handleCCLoadStarted = function (resolve, reject) {
            _this.ccLoadResolve = resolve;
            _this.ccLoadReject = reject;
            _this.state.error = false;
            _this.state.loading = true;
        };
        this.setup = function () {
            if (typeof document === 'undefined') {
                return false;
            }
            var queryFromCurrentURL = _this.windowController && _this.windowController.location && _this.windowController.location.search
                ? queryString.parse(_this.windowController.location.search)
                : {};
            var query = Object.assign({}, {
                appId: _this.props.appId,
                appInstanceId: _this.props.appInstanceId,
                orderId: _this.props.orderId,
                snapshotId: _this.props.orderId
            }, queryFromCurrentURL, _this.props.query);
            _this.queryStringForBuyer = encoder_1.encode(query);
            if (_this.props.selector && _this.props.type === 'BUYER') {
                _this.render(_this.props.selector);
            }
            return true;
        };
        this.render = function (element) {
            return new Promise(function (resolve, reject) {
                if (typeof document === 'undefined') {
                    return reject({
                        status: 'FAILURE',
                        errorCode: '',
                        translatedError: '',
                        paymentMethod: 'creditCard'
                    });
                }
                var node = typeof element === 'string' ? document.querySelector(element) : element;
                var iframe = document.createElement('iframe');
                var iframeLink = (_this.props.linkToIframe || defaultInternals.linkToIframe);
                var divider = iframeLink.indexOf('?') !== -1 ? '&' : '?';
                iframe.src = (_this.props.linkToIframe || defaultInternals.linkToIframe) + (divider + "query=") + _this.queryStringForBuyer;
                iframe.style.width = '100%';
                iframe.style.border = 'none';
                Object.assign(iframe.style, _this.props.styles);
                if (node && node.appendChild) {
                    node.appendChild(iframe);
                }
                else {
                    console.error("Parent element: " + element);
                }
                _this.handleCCLoadStarted(resolve, reject);
                if (_this.props.onMessage) {
                    _this.props.onMessage('creditCard', { type: 'LOAD_STARTED' });
                }
                iframe.onload = function (e) {
                    _this.waitForPingFromCC();
                    if (e.type === 'load' && _this.props.onMessage) {
                        _this.props.onMessage('creditCard', { type: 'LOAD_FINISHED' });
                    }
                };
                _this.iframeNode = iframe;
                _this.listenToMessages();
                return true;
            });
        };
        this.waitForPingFromCC = function () {
            if (!_this.state.loading) {
                return true;
            }
            var TIME_TO_LOAD_CC = 3000;
            _this.ccLoadTimer = setTimeout(function () {
                if (_this.state.loading) {
                    _this.handleCCLoadFinished({ error: true });
                }
            }, TIME_TO_LOAD_CC);
        };
        this.remove = function () {
            if (typeof document === 'undefined') {
                console.error(NO_INIT_MESSAGE);
                return false;
            }
            var parentNode = document.querySelector(_this.props.selector);
            if (parentNode && _this.iframeNode) {
                parentNode.removeChild(_this.iframeNode);
            }
            return true;
        };
        this.lastNumbersOfCard = function () { return postMessagesPubSub_1.emitMessage({
            type: 'getPublicData',
            scope: _this.iframeNode && _this.iframeNode.contentWindow
        }); };
        this.validate = function () {
            return (new Promise(function (resolve, reject) {
                var scope = _this.iframeNode && _this.iframeNode.contentWindow;
                postMessagesPubSub_1.emitMessage({
                    type: 'validate',
                    scope: scope
                })
                    .then(function (payload) {
                    var isValid = payload ? payload.isValid : false;
                    var invalidFields = payload ? payload.invalidFields || [] : [];
                    return resolve({
                        isValid: isValid,
                        invalidFields: invalidFields,
                    });
                })
                    .catch(function (err) { return reject(err); });
            }));
        };
        this.getCreditCardPublicData = function () { return postMessagesPubSub_1.emitMessage({
            type: 'getPublicData',
            scope: _this.iframeNode && _this.iframeNode.contentWindow
        }); };
        this.collapse = function () { return _this.lastNumbersOfCard(); };
        this.expand = function () { return Promise.resolve({ method: 'creditCard', type: 'EXPAND', status: 'expanded' }); };
        this.tokenize = function (mandatoryFields) {
            if (mandatoryFields === void 0) { mandatoryFields = {}; }
            return postMessagesPubSub_1.emitMessage({
                type: 'tokenize',
                payload: { mandatoryFields: mandatoryFields },
                scope: _this.iframeNode && _this.iframeNode.contentWindow,
            });
        };
        this.setInstallments = function (installments) {
            _this.installments = installments;
            return postMessagesPubSub_1.emitMessage({
                type: 'setInstallments',
                payload: { installments: installments },
                scope: _this.iframeNode && _this.iframeNode.contentWindow
            });
        };
        this.pay = function (method, mandatoryFields) {
            if (mandatoryFields === void 0) { mandatoryFields = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var tokenizeResponse, chargeRequest, chargeResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.tokenize(mandatoryFields)];
                        case 1:
                            tokenizeResponse = _a.sent();
                            chargeRequest = {
                                host: this.props.host,
                                request: {
                                    orderId: this.props.orderId,
                                    payment: {
                                        details: {
                                            paymentMethod: method,
                                            installments: this.installments,
                                            creditCardToken: {
                                                token: tokenizeResponse.token.token
                                            }
                                        }
                                    }
                                }
                            };
                            return [4 /*yield*/, paymentsApi_1.default.charge(chargeRequest)];
                        case 2:
                            chargeResponse = _a.sent();
                            return [2 /*return*/, this.props.paymentModule.continuePayment(method, { chargeResponse: chargeResponse })];
                    }
                });
            });
        };
        this.getMetadata = function () {
            return {
                popupSupported: false,
            };
        };
        this.windowController = linkToWindow || window;
        this.props = {
            appId: appId,
            appInstanceId: appInstanceId,
            host: host,
            paymentModule: paymentModule,
            localizeError: localizeError,
            methodId: methodId,
            orderId: orderId,
            linkToIframe: linkToIframe,
            selector: selector,
            styles: styles,
            query: query,
            onMessage: onMessage,
            onPaymentComplete: onPaymentComplete,
            onPaymentStart: onPaymentStart,
            onError: onError,
            type: type
        };
    }
    return CreditCard;
}());
exports.default = CreditCard;
//# sourceMappingURL=CreditCard.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/modules/web/CreditCard.js
// module id = 384
// module chunks = 0 1